import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import AuthService, { features, functionalities, privileges } from '@/shared/services/AuthService';
import messages from './employeeMessages';

const EmployeeGlobalActionsButton = ({
  intl,
  disabled,
  onUpdateInternalPrice,
  onUpdateIntraCompanyPrice,
  onUpdateProfile,
  onUpdateTags,
  onUpdateProductivityPercentage,
  onCreateAbsence,
}) => (
  <span
    className="tool-tip"
    data-toggle="tooltip"
    data-placement="top"
    title={disabled ? intl.formatMessage(messages.EmployeeGlobalActionsTooltip) : ''}
  >
    <DropdownButton
      bsSize="small"
      bsStyle="default"
      className="btn-inverse margin10L"
      id="employee-global-actions-button"
      disabled={disabled}
      pullRight
      title={intl.formatMessage(messages.GlobalActions)}
    >
      <MenuItemWithSecurity
        onSelect={onUpdateInternalPrice}
        functionality={functionalities.EmployeeInternalPrice}
        privilege={privileges.Update}
      >
        {intl.formatMessage(messages.UpdateInternalPrice)}
      </MenuItemWithSecurity>
      {AuthService.hasFeature(features.IntraCompanyBilling) ? (
        <MenuItemWithSecurity
          onSelect={onUpdateIntraCompanyPrice}
          functionality={functionalities.EmployeeInternalPrice}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.UpdateIntraCompanyPrice)}
        </MenuItemWithSecurity>
      ) : null}
      <MenuItemWithSecurity
        onSelect={onUpdateProfile}
        functionality={functionalities.Users}
        privilege={privileges.Update}
      >
        {intl.formatMessage(messages.UpdateProfile)}
      </MenuItemWithSecurity>
      <MenuItemWithSecurity
        onSelect={onUpdateTags}
        functionality={functionalities.Users}
        privilege={privileges.Update}
      >
        {intl.formatMessage(messages.AddOrRemoveTags)}
      </MenuItemWithSecurity>
      {AuthService.hasFeature(features.CapacityPlanning) ? (
        <MenuItemWithSecurity
          onSelect={onUpdateProductivityPercentage}
          functionality={functionalities.CapacityPlanning}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.UpdateProductivityPercentage)}
        </MenuItemWithSecurity>
      ) : null}
      <MenuItemWithSecurity
        onSelect={onCreateAbsence}
        functionality={functionalities.RegistrationOthers}
        privilege={privileges.Create}
      >
        {intl.formatMessage(messages.CreateAbsence)}
      </MenuItemWithSecurity>
    </DropdownButton>
  </span>
);

EmployeeGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  onUpdateInternalPrice: PropTypes.func.isRequired,
  onUpdateIntraCompanyPrice: PropTypes.func.isRequired,
  onUpdateProfile: PropTypes.func.isRequired,
  onUpdateTags: PropTypes.func.isRequired,
  onUpdateProductivityPercentage: PropTypes.func.isRequired,
  onCreateAbsence: PropTypes.func.isRequired,
};

EmployeeGlobalActionsButton.defaultProps = { disabled: false };

export default injectIntl(EmployeeGlobalActionsButton);
